import React, { useEffect, useState } from "react";
import "./Edit_Patron_Portfolio.css";
import Patron_Navbar from "../../Patron_Navbar";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
  makeAuthenticatedGETRequest,
  makeAuthenticatedPATCHRequest,
  makeAuthenticated_Multi_Patch_REQ,
} from "../../../services/serverHelper";
import { patronProfilePoints } from "../../../services/apis";
import { useSelector } from "react-redux";
import { BsCheckLg } from "react-icons/bs";
import {
  AiOutlineMail,
  AiOutlinePhone,
  AiOutlineGlobal,
  AiOutlineEnvironment,
  AiOutlineCamera,
  AiOutlineSave,
} from "react-icons/ai";
import { MdBusinessCenter, MdPerson } from "react-icons/md";

export default function Edit_Patron_Portfolio() {
  const [profileAvatar, setProfileAvatar] = useState("");
  const navigate = useNavigate();
  const { accessToken } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState([]);

  const [formData, setFormData] = useState({
    personalInfo: {
      profession: "",
      companyName: "",
      authorizedPerson: "",
      designation: "",
      companyDescription: "",
      firstName: "",
      lastName: "",
    },
    address: {
      state: "",
      city: "",
      pincode: "",
      details: "",
    },
    contactDetails: "",
    contactInfo: {
      email: "",
      contactNumber: "",
      website: "",
    },
    expectations: "",
  });

  const changeHandler = (event) => {
    const { name, value } = event.target;
    const [section, property] = name.split(".");

    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [property]: value,
      },
    }));
  };

  const changeExpectationsHandler = (event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      expectations: value,
    }));
  };

  const fetchPatronData = async () => {
    const toastId = toast.loading("Loading...");
    try {
      const response = await makeAuthenticatedGETRequest(
        `${patronProfilePoints.FETCH_PATRON_APPLI_API}/${localStorage.getItem("artId")}`,
        accessToken
      );
      console.log("res", response.data);
      if (response.status === "success") {
        setUserData(response.data);
        setFormData(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("internal server error, please try again");
    }
    toast.dismiss(toastId);
  };

  useEffect(() => {
    fetchPatronData();
  }, []);

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const citiesByState = {
    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"],
    "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Tawang", "Pasighat", "Ziro"],
    Assam: ["Guwahati", "Jorhat", "Dibrugarh", "Silchar", "Nagaon"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur", "Darbhanga"],
    Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Raigarh"],
    Goa: ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    Haryana: ["Faridabad", "Gurugram", "Rohtak", "Panipat", "Karnal"],
    "Himachal Pradesh": ["Shimla", "Mandi", "Solan", "Dharamshala", "Kullu"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
    Karnataka: ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
    "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching"],
    Meghalaya: ["Shillong", "Tura", "Jowai", "Nongpoh", "Williamnagar"],
    Mizoram: ["Aizawl", "Lunglei", "Champhai", "Saiha", "Kolasib"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
    Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner"],
    Sikkim: ["Gangtok", "Namchi", "Mangan", "Singtam", "Gyalshing"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
    Tripura: ["Agartala", "Dharmanagar", "Udaipur", "Kailashahar", "Belonia"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Allahabad"],
    Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  };

  const updatePtronData = async (event) => {
    console.log(formData);
    event.preventDefault();

    const toastId = toast.loading("Loading...");
    try {
      const response = await makeAuthenticatedPATCHRequest(
        `${patronProfilePoints.FETCH_PATRON_APPLI_API}/${localStorage.getItem("artId")}`,
        formData,
        accessToken
      );
      console.log("resss", response.data);
      if (response.status === "success") {
        toast.success("successfully updated");
        navigate(-1);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Internal server error, please try again");
    }
    toast.dismiss(toastId);
  };

  const handleButtonClick = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".jpg, .jpeg, .png";
    fileInput.onchange = handleFileChange;
    fileInput.click();
  };

  const handleFileChange = async (event) => {
    const toastId = toast.loading("Loading...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      console.log("sele", selectedFile);

      const formData = new FormData();
      formData.append("avatar", selectedFile);

      const response = await makeAuthenticated_Multi_Patch_REQ(
        patronProfilePoints.PATRON_AVATAR_UPDATE,
        formData,
        accessToken
      );
      console.log("res", response);
      setProfileAvatar(response?.data?.avatar);
    }

    toast.success("Successfully Updated Profile Picture");
    toast.dismiss(toastId);
    navigate(-1);
  };

  // const getAvatarUrl = () => {
  //   if (userData?.personalInfo?.avatar?.url) {
  //     return userData.personalInfo.avatar.url;
  //   }
  //   return `https://ui-avatars.com/api/?name=${formData.personalInfo.firstName}+${formData.personalInfo.lastName}&background=AD2F3B&color=fff&size=200`;
  // };

  const getAvatarUrl = (imageValue) => {
    if (!imageValue) return "/default-avatar.png";

    try {
      let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
      if (!raw) return "/default-avatar.png";

      // blob URL (local preview)
      if (raw.startsWith("blob:")) return raw;

      // If string contains absolute URL anywhere (sometimes backend returns weird concatenation), extract first http(s)
      const absMatch = raw.match(/https?:\/\/[^\s]+/i);
      if (absMatch && absMatch[0]) {
        // return absolute URL directly (preserve)
        return absMatch[0];
      }

      // protocol-relative
      if (raw.startsWith("//")) return "https:" + raw;

      // strip leading slashes and common prefixes
      let cleaned = raw
        .replace(/^\/+/, "")
        .replace(/^public\/images\//i, "")
        .replace(/^public\/uploads\//i, "")
        .replace(/^uploads\/performance\//i, "")
        .replace(/^uploads\//i, "")
        .replace(/^images\//i, "")
        .replace(/^api\/v1\/images\//i, "")
        .replace(/^api\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
        .trim();

      // Build host from env or default
      const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
      // Ensure we keep only host (strip any /api/v1 etc)
      let API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/i, "");
      if (!API_HOST.startsWith("http")) {
        API_HOST = "https://" + API_HOST;
      }

      // Use /images/<filename> endpoint which your backend serves
      return `${API_HOST}/images/${cleaned}`;
    } catch (err) {
      console.error("getFullImageUrl error:", err, imageValue);
      return "/default-avatar.png";
    }
  };

  return (
    <>
      <Patron_Navbar />
      <div className="modern_edit_patron_page">
        <div className="modern_edit_container">
          <h1 className="modern_edit_page_title">Edit Portfolio</h1>

          {/* Hero Card */}
          <div className="modern_edit_hero_card">
            <div className="modern_edit_hero_gradient">
              <div className="modern_edit_hero_pattern"></div>
              <div className="modern_edit_hero_content">
                {/* Avatar Section */}
                <div className="modern_edit_avatar_section">
                  <div className="modern_edit_avatar_wrapper">
                    <img
                      loading="lazy"
                      src={getAvatarUrl(userData?.personalInfo?.avatar?.url )}
                      alt="Profile"
                      className="modern_edit_avatar_image"
                    />
                    <div className="modern_edit_verified_badge">
                      <BsCheckLg className="modern_edit_verified_icon" />
                    </div>
                  </div>
                </div>

                {/* Info Section */}
                <div className="modern_edit_info_section">
                  <h1 className="modern_edit_patron_name">
                    {userData?.personalInfo?.firstName} {userData?.personalInfo?.lastName}
                  </h1>
                  <div className="modern_edit_badges_wrapper">
                    <span className="modern_edit_badge">
                      <MdBusinessCenter className="modern_edit_badge_icon" />
                      {userData?.personalInfo?.companyName}
                    </span>
                    <span className="modern_edit_badge">
                      <MdPerson className="modern_edit_badge_icon" />
                      {userData?.personalInfo?.profession}
                    </span>
                  </div>

                  {/* Contact Info */}
                  <div className="modern_edit_contact_quick">
                    <div className="modern_edit_contact_item">
                      <AiOutlinePhone className="modern_edit_contact_icon" />
                      <span>{userData?.contactDetails?.contactNumber}</span>
                    </div>
                    <div className="modern_edit_contact_item">
                      <AiOutlineMail className="modern_edit_contact_icon" />
                      <span>{userData?.contactDetails?.email}</span>
                    </div>
                    <div className="modern_edit_contact_item">
                      <AiOutlineEnvironment className="modern_edit_contact_icon" />
                      <span>
                        {userData?.address?.city}, {userData?.address?.state}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Logo Section */}
                {/* <div className="modern_edit_logo_section">
                  <div className="modern_edit_logo_box">
                    <img
                      src="assets/HomePage/eK_Logo_Trasnparent_1.png"
                      alt="eKalakaar Logo"
                      className="modern_edit_ek_logo"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Upload Button */}
          <button onClick={handleButtonClick} className="modern_edit_upload_button">
            <AiOutlineCamera className="modern_edit_upload_icon" />
            Upload Profile Picture
          </button>

          {/* Edit Form */}
          <form onSubmit={updatePtronData} className="modern_edit_form">
            {/* About Company */}
            <div className="modern_edit_card">
              <h2 className="modern_edit_card_title">
                <div className="modern_edit_title_accent"></div>
                About the Company
              </h2>
              <textarea
                name="personalInfo.companyDescription"
                onChange={changeHandler}
                value={formData.personalInfo.companyDescription}
                className="modern_edit_textarea"
                placeholder="Describe your company..."
              />
            </div>

            {/* Professional Details */}
            <div className="modern_edit_card">
              <h2 className="modern_edit_card_title">
                <div className="modern_edit_title_accent"></div>
                Professional Details
              </h2>
              <div className="modern_edit_grid">
                <div className="modern_edit_field">
                  <label className="modern_edit_label">First Name*</label>
                  <input
                    name="personalInfo.firstName"
                    onChange={changeHandler}
                    value={formData.personalInfo.firstName}
                    className="modern_edit_input"
                    required
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Last Name*</label>
                  <input
                    name="personalInfo.lastName"
                    onChange={changeHandler}
                    value={formData.personalInfo.lastName}
                    className="modern_edit_input"
                    required
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Profession</label>
                  <input
                    name="personalInfo.profession"
                    onChange={changeHandler}
                    value={formData.personalInfo.profession}
                    className="modern_edit_input"
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Company Name</label>
                  <input
                    name="personalInfo.companyName"
                    onChange={changeHandler}
                    value={formData.personalInfo.companyName}
                    className="modern_edit_input"
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Authorized Person</label>
                  <input
                    name="personalInfo.authorizedPerson"
                    onChange={changeHandler}
                    value={formData.personalInfo.authorizedPerson}
                    className="modern_edit_input"
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Designation</label>
                  <input
                    name="personalInfo.designation"
                    onChange={changeHandler}
                    value={formData.personalInfo.designation}
                    className="modern_edit_input"
                  />
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="modern_edit_card">
              <h2 className="modern_edit_card_title">
                <div className="modern_edit_title_accent"></div>
                Address
              </h2>
              <div className="modern_edit_grid">
                <div className="modern_edit_field modern_edit_pincode">
                  <label className="modern_edit_label">Pincode*</label>
                  <input
                    name="address.pincode"
                    maxLength={6}
                    pattern="[0-9]{6}"
                    onChange={changeHandler}
                    value={formData.address.pincode}
                    className="modern_edit_input"
                    required
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">State*</label>
                  <select
                    name="address.state"
                    onChange={changeHandler}
                    value={formData.address.state}
                    className="modern_edit_input"
                    required
                  >
                    <option value="">Select State</option>
                    {indianStates.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">City*</label>
                  <select
                    name="address.city"
                    onChange={changeHandler}
                    value={formData.address.city}
                    className="modern_edit_input"
                    required
                  >
                    <option value="">Select City</option>
                    {formData.address.state &&
                      citiesByState[formData.address.state] &&
                      citiesByState[formData.address.state].map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Contact Details */}
            <div className="modern_edit_card">
              <h2 className="modern_edit_card_title">
                <div className="modern_edit_title_accent"></div>
                Contact Information
              </h2>
              <div className="modern_edit_grid">
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Company Email*</label>
                  <input
                    name="contactDetails.email"
                    type="email"
                    onChange={changeHandler}
                    value={formData?.contactDetails?.email}
                    className="modern_edit_input"
                    required
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Contact Number*</label>
                  <input
                    name="contactDetails.contactNumber"
                    onChange={changeHandler}
                    value={formData?.contactDetails?.contactNumber}
                    className="modern_edit_input"
                    required
                  />
                </div>
                <div className="modern_edit_field">
                  <label className="modern_edit_label">Website</label>
                  <input
                    name="contactDetails.website"
                    onChange={changeHandler}
                    value={formData?.contactDetails?.website}
                    className="modern_edit_input"
                  />
                </div>
                <div className="modern_edit_field modern_edit_full_width">
                  <label className="modern_edit_label">
                    Expectations from eKalakaar
                  </label>
                  <textarea
                    name="expectations"
                    onChange={changeExpectationsHandler}
                    value={formData.expectations}
                    className="modern_edit_textarea modern_edit_textarea_small"
                    placeholder="Share your expectations..."
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <button type="submit" className="modern_edit_submit_button">
              <AiOutlineSave className="modern_edit_submit_icon" />
              Update Portfolio
            </button>
          </form>
        </div>
      </div>
    </>
  );
}